import Dashboard from '@/pages/dashboard/Dashboard';

const dashboardRoutes = [
  {
    path: '',
    element: Dashboard,
  },
];

export default dashboardRoutes;
